import { toString } from "../../../lib/utils/string";
const paramsSchema = {
  type: 'object',
  fields: [{
    id: 'type',
    type: 'string',
    enum: [{
      value: 'info'
    }, {
      value: 'error'
    }, {
      value: 'success'
    }, {
      value: 'warn'
    }]
  }, {
    id: 'text',
    type: 'string',
    title: '文案',
    default: '请设置文案',
    ui: {
      settings: {
        multipleLine: true
      }
    }
  }]
};
export const messageAtom = {
  id: 'uicore:message',
  name: '弹出提示',
  category: 'UI交互',
  paramsSchema: paramsSchema,
  execute: async (ctx, params) => {
    const uc = ctx.uc;
    await uc.$message[params.type](toString(params.text));
  }
};
//# sourceMappingURL=messageAtom.js.map
